import { ArrowUp, Square } from "lucide-react";
import { Button } from "~/components/ui/button";
import { cn } from "~/lib/utils";

interface SendButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  isCancelling?: boolean;
}

export function SendButton({
  onClick,
  disabled = false,
  isLoading = false,
  isCancelling = false,
}: SendButtonProps) {
  // Stop button disabled while cancelling; Send button uses disabled prop
  const isDisabled = isLoading ? isCancelling : disabled;

  const ariaLabel = !isLoading
    ? "Send message"
    : isCancelling
      ? "Cancelling..."
      : "Stop generation";

  return (
    <Button
      onClick={onClick}
      disabled={isDisabled}
      size="icon"
      className={cn(
        "w-7 h-7 rounded-full transition-all duration-200",
        isDisabled
          ? "bg-gray-300 cursor-not-allowed"
          : "bg-primary hover:bg-primary/80 cursor-pointer"
      )}
      aria-label={ariaLabel}
    >
      {isLoading ? (
        <Square className="size-3.5 text-white fill-white" />
      ) : (
        <ArrowUp className="size-4 text-white" />
      )}
    </Button>
  );
}
